import ImageNavigation from './ImageNavigation'

export * from './ImageNavigation'

export default ImageNavigation
